/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface OrderReportBase
 */
export interface OrderReportBaseOptional {
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountPaidLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountBaseLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountSubtotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountTaxesLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountTotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountDiscountLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountPaymentsPaid?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountStripePaymentsPaid?: number;
}

export interface OrderReportBase extends OrderReportBaseOptional {
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountPaidLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountBaseLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountSubtotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountTaxesLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountTotalLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountDiscountLineItems?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountPaymentsPaid?: number;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountStripePaymentsPaid?: number;
}

export interface OrderReportBaseTrackedI {
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountPaidLineItems?: number;
  totalAmountPaidLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountBaseLineItems?: number;
  totalAmountBaseLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountSubtotalLineItems?: number;
  totalAmountSubtotalLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountTaxesLineItems?: number;
  totalAmountTaxesLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountTotalLineItems?: number;
  totalAmountTotalLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountDiscountLineItems?: number;
  totalAmountDiscountLineItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountPaymentsPaid?: number;
  totalAmountPaymentsPaidIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderReportBase
   */
  totalAmountStripePaymentsPaid?: number;
  totalAmountStripePaymentsPaidIsSet: boolean;
}

transformDatesMap.set("OrderReportBase", function (model: OrderReportBase) {});

export type OrderReportBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  totalAmountPaidLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountBaseLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountSubtotalLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountTaxesLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountTotalLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountDiscountLineItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountPaymentsPaid: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountStripePaymentsPaid: PropertyMeta<MetaTypeBase<number>>;
}>;

export var OrderReportBaseMeta: OrderReportBaseMetaI =
  {} as OrderReportBaseMetaI;
OrderReportBaseMeta = typeMeta("OrderReportBase", {
  totalAmountPaidLineItems: propertyMeta(
    "totalAmountPaidLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountBaseLineItems: propertyMeta(
    "totalAmountBaseLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountSubtotalLineItems: propertyMeta(
    "totalAmountSubtotalLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountTaxesLineItems: propertyMeta(
    "totalAmountTaxesLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountTotalLineItems: propertyMeta(
    "totalAmountTotalLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountDiscountLineItems: propertyMeta(
    "totalAmountDiscountLineItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountPaymentsPaid: propertyMeta(
    "totalAmountPaymentsPaid",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountStripePaymentsPaid: propertyMeta(
    "totalAmountStripePaymentsPaid",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = OrderReportBaseMeta;

registerMeta(() => {});

export class OrderReportBaseTracked implements OrderReportBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  totalAmountPaidLineItems__I?: number = undefined;
  totalAmountPaidLineItemsIsSet: boolean = false;
  set totalAmountPaidLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountPaidLineItems__I = v;
      this.totalAmountPaidLineItemsIsSet = true;
    } else {
      this.totalAmountPaidLineItems__I = v || undefined;
      this.totalAmountPaidLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountPaidLineItems() {
    return this.totalAmountPaidLineItems__I;
  }
  totalAmountBaseLineItems__I?: number = undefined;
  totalAmountBaseLineItemsIsSet: boolean = false;
  set totalAmountBaseLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountBaseLineItems__I = v;
      this.totalAmountBaseLineItemsIsSet = true;
    } else {
      this.totalAmountBaseLineItems__I = v || undefined;
      this.totalAmountBaseLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountBaseLineItems() {
    return this.totalAmountBaseLineItems__I;
  }
  totalAmountSubtotalLineItems__I?: number = undefined;
  totalAmountSubtotalLineItemsIsSet: boolean = false;
  set totalAmountSubtotalLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountSubtotalLineItems__I = v;
      this.totalAmountSubtotalLineItemsIsSet = true;
    } else {
      this.totalAmountSubtotalLineItems__I = v || undefined;
      this.totalAmountSubtotalLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountSubtotalLineItems() {
    return this.totalAmountSubtotalLineItems__I;
  }
  totalAmountTaxesLineItems__I?: number = undefined;
  totalAmountTaxesLineItemsIsSet: boolean = false;
  set totalAmountTaxesLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountTaxesLineItems__I = v;
      this.totalAmountTaxesLineItemsIsSet = true;
    } else {
      this.totalAmountTaxesLineItems__I = v || undefined;
      this.totalAmountTaxesLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountTaxesLineItems() {
    return this.totalAmountTaxesLineItems__I;
  }
  totalAmountTotalLineItems__I?: number = undefined;
  totalAmountTotalLineItemsIsSet: boolean = false;
  set totalAmountTotalLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountTotalLineItems__I = v;
      this.totalAmountTotalLineItemsIsSet = true;
    } else {
      this.totalAmountTotalLineItems__I = v || undefined;
      this.totalAmountTotalLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountTotalLineItems() {
    return this.totalAmountTotalLineItems__I;
  }
  totalAmountDiscountLineItems__I?: number = undefined;
  totalAmountDiscountLineItemsIsSet: boolean = false;
  set totalAmountDiscountLineItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountDiscountLineItems__I = v;
      this.totalAmountDiscountLineItemsIsSet = true;
    } else {
      this.totalAmountDiscountLineItems__I = v || undefined;
      this.totalAmountDiscountLineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountDiscountLineItems() {
    return this.totalAmountDiscountLineItems__I;
  }
  totalAmountPaymentsPaid__I?: number = undefined;
  totalAmountPaymentsPaidIsSet: boolean = false;
  set totalAmountPaymentsPaid(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountPaymentsPaid__I = v;
      this.totalAmountPaymentsPaidIsSet = true;
    } else {
      this.totalAmountPaymentsPaid__I = v || undefined;
      this.totalAmountPaymentsPaidIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountPaymentsPaid() {
    return this.totalAmountPaymentsPaid__I;
  }
  totalAmountStripePaymentsPaid__I?: number = undefined;
  totalAmountStripePaymentsPaidIsSet: boolean = false;
  set totalAmountStripePaymentsPaid(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountStripePaymentsPaid__I = v;
      this.totalAmountStripePaymentsPaidIsSet = true;
    } else {
      this.totalAmountStripePaymentsPaid__I = v || undefined;
      this.totalAmountStripePaymentsPaidIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountStripePaymentsPaid() {
    return this.totalAmountStripePaymentsPaid__I;
  }
  constructor(config?: OrderReportBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: OrderReportBaseOptional,
    options?: AssignOptions,
  ): OrderReportBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.totalAmountPaidLineItems &&
      this.totalAmountPaidLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountPaidLineItems = config.totalAmountPaidLineItems;
      if (optionsRequired.unassign) this.totalAmountPaidLineItemsIsSet = false;
      else this.totalAmountPaidLineItemsIsSet = true;
    }
    if (
      config.totalAmountBaseLineItems &&
      this.totalAmountBaseLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountBaseLineItems = config.totalAmountBaseLineItems;
      if (optionsRequired.unassign) this.totalAmountBaseLineItemsIsSet = false;
      else this.totalAmountBaseLineItemsIsSet = true;
    }
    if (
      config.totalAmountSubtotalLineItems &&
      this.totalAmountSubtotalLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountSubtotalLineItems = config.totalAmountSubtotalLineItems;
      if (optionsRequired.unassign)
        this.totalAmountSubtotalLineItemsIsSet = false;
      else this.totalAmountSubtotalLineItemsIsSet = true;
    }
    if (
      config.totalAmountTaxesLineItems &&
      this.totalAmountTaxesLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountTaxesLineItems = config.totalAmountTaxesLineItems;
      if (optionsRequired.unassign) this.totalAmountTaxesLineItemsIsSet = false;
      else this.totalAmountTaxesLineItemsIsSet = true;
    }
    if (
      config.totalAmountTotalLineItems &&
      this.totalAmountTotalLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountTotalLineItems = config.totalAmountTotalLineItems;
      if (optionsRequired.unassign) this.totalAmountTotalLineItemsIsSet = false;
      else this.totalAmountTotalLineItemsIsSet = true;
    }
    if (
      config.totalAmountDiscountLineItems &&
      this.totalAmountDiscountLineItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountDiscountLineItems = config.totalAmountDiscountLineItems;
      if (optionsRequired.unassign)
        this.totalAmountDiscountLineItemsIsSet = false;
      else this.totalAmountDiscountLineItemsIsSet = true;
    }
    if (
      config.totalAmountPaymentsPaid &&
      this.totalAmountPaymentsPaidApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountPaymentsPaid = config.totalAmountPaymentsPaid;
      if (optionsRequired.unassign) this.totalAmountPaymentsPaidIsSet = false;
      else this.totalAmountPaymentsPaidIsSet = true;
    }
    if (
      config.totalAmountStripePaymentsPaid &&
      this.totalAmountStripePaymentsPaidApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountStripePaymentsPaid = config.totalAmountStripePaymentsPaid;
      if (optionsRequired.unassign)
        this.totalAmountStripePaymentsPaidIsSet = false;
      else this.totalAmountStripePaymentsPaidIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderReportBaseTrackedI {
    const cloned = {} as OrderReportBaseTrackedI;
    if (
      this.totalAmountPaidLineItemsIsSetDeep() &&
      this.totalAmountPaidLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountPaidLineItemsIsSet = true;
      cloned.totalAmountPaidLineItems = this.totalAmountPaidLineItems;
    } else {
      //cloned.totalAmountPaidLineItemsIsSet = false
    }
    if (
      this.totalAmountBaseLineItemsIsSetDeep() &&
      this.totalAmountBaseLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountBaseLineItemsIsSet = true;
      cloned.totalAmountBaseLineItems = this.totalAmountBaseLineItems;
    } else {
      //cloned.totalAmountBaseLineItemsIsSet = false
    }
    if (
      this.totalAmountSubtotalLineItemsIsSetDeep() &&
      this.totalAmountSubtotalLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountSubtotalLineItemsIsSet = true;
      cloned.totalAmountSubtotalLineItems = this.totalAmountSubtotalLineItems;
    } else {
      //cloned.totalAmountSubtotalLineItemsIsSet = false
    }
    if (
      this.totalAmountTaxesLineItemsIsSetDeep() &&
      this.totalAmountTaxesLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountTaxesLineItemsIsSet = true;
      cloned.totalAmountTaxesLineItems = this.totalAmountTaxesLineItems;
    } else {
      //cloned.totalAmountTaxesLineItemsIsSet = false
    }
    if (
      this.totalAmountTotalLineItemsIsSetDeep() &&
      this.totalAmountTotalLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountTotalLineItemsIsSet = true;
      cloned.totalAmountTotalLineItems = this.totalAmountTotalLineItems;
    } else {
      //cloned.totalAmountTotalLineItemsIsSet = false
    }
    if (
      this.totalAmountDiscountLineItemsIsSetDeep() &&
      this.totalAmountDiscountLineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountDiscountLineItemsIsSet = true;
      cloned.totalAmountDiscountLineItems = this.totalAmountDiscountLineItems;
    } else {
      //cloned.totalAmountDiscountLineItemsIsSet = false
    }
    if (
      this.totalAmountPaymentsPaidIsSetDeep() &&
      this.totalAmountPaymentsPaidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountPaymentsPaidIsSet = true;
      cloned.totalAmountPaymentsPaid = this.totalAmountPaymentsPaid;
    } else {
      //cloned.totalAmountPaymentsPaidIsSet = false
    }
    if (
      this.totalAmountStripePaymentsPaidIsSetDeep() &&
      this.totalAmountStripePaymentsPaidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountStripePaymentsPaidIsSet = true;
      cloned.totalAmountStripePaymentsPaid = this.totalAmountStripePaymentsPaid;
    } else {
      //cloned.totalAmountStripePaymentsPaidIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderReportBaseTrackedI {
    if (!this.totalAmountPaidLineItemsApplyFilter(filter))
      this.totalAmountPaidLineItemsIsSet = false;

    if (!this.totalAmountBaseLineItemsApplyFilter(filter))
      this.totalAmountBaseLineItemsIsSet = false;

    if (!this.totalAmountSubtotalLineItemsApplyFilter(filter))
      this.totalAmountSubtotalLineItemsIsSet = false;

    if (!this.totalAmountTaxesLineItemsApplyFilter(filter))
      this.totalAmountTaxesLineItemsIsSet = false;

    if (!this.totalAmountTotalLineItemsApplyFilter(filter))
      this.totalAmountTotalLineItemsIsSet = false;

    if (!this.totalAmountDiscountLineItemsApplyFilter(filter))
      this.totalAmountDiscountLineItemsIsSet = false;

    if (!this.totalAmountPaymentsPaidApplyFilter(filter))
      this.totalAmountPaymentsPaidIsSet = false;

    if (!this.totalAmountStripePaymentsPaidApplyFilter(filter))
      this.totalAmountStripePaymentsPaidIsSet = false;

    return this;
  }
  totalAmountPaidLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportBaseMeta.totalAmountPaidLineItems,
      OrderReportBaseMeta,
      this.totalAmountPaidLineItems,
      this,
    );
  }
  totalAmountPaidLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountPaidLineItemsIsSet &&
      this.totalAmountPaidLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountBaseLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportBaseMeta.totalAmountBaseLineItems,
      OrderReportBaseMeta,
      this.totalAmountBaseLineItems,
      this,
    );
  }
  totalAmountBaseLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountBaseLineItemsIsSet &&
      this.totalAmountBaseLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountSubtotalLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportBaseMeta.totalAmountSubtotalLineItems,
      OrderReportBaseMeta,
      this.totalAmountSubtotalLineItems,
      this,
    );
  }
  totalAmountSubtotalLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountSubtotalLineItemsIsSet &&
      this.totalAmountSubtotalLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountTaxesLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportBaseMeta.totalAmountTaxesLineItems,
      OrderReportBaseMeta,
      this.totalAmountTaxesLineItems,
      this,
    );
  }
  totalAmountTaxesLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountTaxesLineItemsIsSet &&
      this.totalAmountTaxesLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountTotalLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportBaseMeta.totalAmountTotalLineItems,
      OrderReportBaseMeta,
      this.totalAmountTotalLineItems,
      this,
    );
  }
  totalAmountTotalLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountTotalLineItemsIsSet &&
      this.totalAmountTotalLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountDiscountLineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportBaseMeta.totalAmountDiscountLineItems,
      OrderReportBaseMeta,
      this.totalAmountDiscountLineItems,
      this,
    );
  }
  totalAmountDiscountLineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountDiscountLineItemsIsSet &&
      this.totalAmountDiscountLineItemsApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountPaymentsPaidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportBaseMeta.totalAmountPaymentsPaid,
      OrderReportBaseMeta,
      this.totalAmountPaymentsPaid,
      this,
    );
  }
  totalAmountPaymentsPaidIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountPaymentsPaidIsSet &&
      this.totalAmountPaymentsPaidApplyFilter(filter)
    )
      return true;

    return false;
  }
  totalAmountStripePaymentsPaidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportBaseMeta.totalAmountStripePaymentsPaid,
      OrderReportBaseMeta,
      this.totalAmountStripePaymentsPaid,
      this,
    );
  }
  totalAmountStripePaymentsPaidIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountStripePaymentsPaidIsSet &&
      this.totalAmountStripePaymentsPaidApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.totalAmountPaidLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountBaseLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountSubtotalLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountTaxesLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountTotalLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountDiscountLineItemsIsSetDeep(filter)) return true;
    if (this.totalAmountPaymentsPaidIsSetDeep(filter)) return true;
    if (this.totalAmountStripePaymentsPaidIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
